import { PAIRS_BY_SIZE } from '../constants/memorama'
import { CARD_INFO } from '../constants/cards'

/**
 * Generates a shuffled deck of card pairs with random card selection.
 *
 * Depends strictly on CARD_INFO, and requires at least `totalPairs` entries.
 * If not enough cards are available, the function will log a warning and use as many as possible.
 * It automatically scales with the number of cards available in CARD_INFO.
 * It automatically duplicates cards to fill the required pairs.
 */

export function generateDeck (boardSize = 'xs') {
  const totalPairs = PAIRS_BY_SIZE[boardSize] || PAIRS_BY_SIZE.xs

  // NOTE: CARD_INFO is a controlled constant, but we still validate it defensively
  // to catch issues early during development or future refactors.

  if (CARD_INFO.length < totalPairs) {
    if (import.meta.env.MODE === 'development') {
      console.warn(`[generateDeck] Requested ${totalPairs} pairs, but only ${CARD_INFO.length} cards available.`)
    }
  }
  const pairsToUse = Math.min(totalPairs, CARD_INFO.length)

  const shuffledCardPool = fisherYatesShuffle([...CARD_INFO])
  const selectedCards = shuffledCardPool.slice(0, pairsToUse)

  const rawCards = []

  selectedCards.forEach((card, index) => {
    if (!card || !card.image || !card.name) {
      if (import.meta.env.MODE === 'development') {
        console.warn('[generateDeck] Invalid card at index', index, card)
      }
      return
    }

    // Duplicate each image to form a pair
    rawCards.push(
      {
        id: `${index + 1}-a`,
        image: card.image,
        name: card.name,
        translationKey: card.translationKey,
        flipped: false,
        matched: false
      },
      {
        id: `${index + 1}-b`,
        image: card.image,
        name: card.name,
        translationKey: card.translationKey,
        flipped: false,
        matched: false
      }
    )
  })

  // Shuffle cards randomly
  return fisherYatesShuffle(rawCards)
}

function fisherYatesShuffle (array) {
  const result = [...array]
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }
  return result
}
